module.exports = __webpack_public_path__ + "static/media/work_with_households_icon_active.e09a6f34.svg";